import React from 'react';
import { useStorage } from '../use-storage';
export function useSessionStorage(key, defaultValue) {
    const getStorage = React.useCallback(() => (typeof window === 'undefined' ? null : window.sessionStorage), [typeof window]);
    return useStorage(key, getStorage, defaultValue);
}
